package it.neckar.lizergy.model.customer

object AddressExample {
  val holstenwall: Address = Address("Holstenwall", "85", "06548", "Rottleberode", "Germany")
  val albrechtstrasse: Address = Address("Albrechtstrasse", "30", "86305", "Friedberg", "Germany")
  val gotthardstrasse: Address = Address("Gotthardstrasse", "42a", "09112", "Chemnitz", "Germany")
  val lindenstrasse: Address = Address("Lindenstraße", "12", "10115", "Berlin", "Germany")
  val bahnhofstrasse: Address = Address("Bahnhofstraße", "5", "80331", "München", "Germany")
  val marktstrasse: Address = Address("Marktstraße", "3", "50667", "Köln", "Germany")
  val hauptstrasse: Address = Address("Hauptstraße", "77", "20095", "Hamburg", "Germany")
  val gartenweg: Address = Address("Gartenweg", "9", "04109", "Leipzig", "Germany")
  val sonnenallee: Address = Address("Sonnenallee", "120", "12045", "Berlin", "Germany")
  val schlossweg: Address = Address("Schlossweg", "8", "68159", "Mannheim", "Germany")
  val ringstrasse: Address = Address("Ringstraße", "21", "90402", "Nürnberg", "Germany")
  val buchenweg: Address = Address("Buchenweg", "14", "70563", "Stuttgart", "Germany")
  val ahornstrasse: Address = Address("Ahornstraße", "6", "89073", "Ulm", "Germany")
  val kirchgasse: Address = Address("Kirchgasse", "2", "65183", "Wiesbaden", "Germany")
  val birkenweg: Address = Address("Birkenweg", "17", "14467", "Potsdam", "Germany")
  val dammstrasse: Address = Address("Dammstraße", "40", "39104", "Magdeburg", "Germany")
  val amSportplatz: Address = Address("Am Sportplatz", "1", "04105", "Leipzig", "Germany")
  val beethovenstrasse: Address = Address("Beethovenstraße", "11", "01069", "Dresden", "Germany")
  val koelnerStrasse: Address = Address("Kölner Straße", "55", "40211", "Düsseldorf", "Germany")
  val brunnenweg: Address = Address("Brunnenweg", "18", "67655", "Kaiserslautern", "Germany")
  val hafenstrasse: Address = Address("Hafenstraße", "31", "27568", "Bremerhaven", "Germany")
  val fliederweg: Address = Address("Fliederweg", "24", "85049", "Ingolstadt", "Germany")

  val avenueDesChamps: Address = Address("Avenue des Champs-Élysées", "50", "75008", "Paris", "France")
  val oxfordStreet: Address = Address("Oxford Street", "120", "W1D 1LT", "London", "United Kingdom")
  val granVia: Address = Address("Gran Via", "45", "28013", "Madrid", "Spain")
  val corsoVenezia: Address = Address("Corso Venezia", "15", "20121", "Milan", "Italy")
  val karlJohansGate: Address = Address("Karl Johans gate", "22", "0159", "Oslo", "Norway")
  val damrak: Address = Address("Damrak", "1", "1012LG", "Amsterdam", "Netherlands")
  val kaiserstrasse: Address = Address("Kaiserstraße", "10", "1010", "Vienna", "Austria")
  val fifthAvenue: Address = Address("Fifth Avenue", "350", "10001", "New York", "USA")
  val collinsStreet: Address = Address("Collins Street", "455", "3000", "Melbourne", "Australia")
  val robsonStreet: Address = Address("Robson Street", "789", "V6E 1B5", "Vancouver", "Canada")

  val addresses: List<Address> =
    listOf(
      holstenwall,
      albrechtstrasse,
      gotthardstrasse,
      lindenstrasse,
      bahnhofstrasse,
      marktstrasse,
      hauptstrasse,
      gartenweg,
      sonnenallee,
      schlossweg,
      ringstrasse,
      buchenweg,
      ahornstrasse,
      kirchgasse,
      birkenweg,
      dammstrasse,
      amSportplatz,
      beethovenstrasse,
      koelnerStrasse,
      brunnenweg,
      hafenstrasse,
      fliederweg,
      avenueDesChamps,
      oxfordStreet,
      granVia,
      corsoVenezia,
      karlJohansGate,
      damrak,
      kaiserstrasse,
      fifthAvenue,
      collinsStreet,
      robsonStreet
    )

  val addressesGermany = listOf(
    holstenwall,
    albrechtstrasse,
    gotthardstrasse,
    lindenstrasse,
    bahnhofstrasse,
    marktstrasse,
    hauptstrasse,
    gartenweg,
    sonnenallee,
    schlossweg,
    ringstrasse,
    buchenweg,
    ahornstrasse,
    kirchgasse,
    birkenweg,
    dammstrasse,
    amSportplatz,
    beethovenstrasse,
    koelnerStrasse,
    brunnenweg,
    hafenstrasse,
    fliederweg
  )

  val neckarIT: Address = Address("Ulrichstraße", "25", "72116", "Mössingen", "Germany")
  val muster: Address = Address("Musterstraße", "99", "77777", "Musterstadt", "Germany")
  val lizergy: Address = Address("Jaspisstraße", "13", "72250", "Freudenstadt", "Germany")
  val schnitzer: Address = Address("Sebastiansweilerstrasse", "13", "72116", "Mössingen-Belsen", "Germany")

  val test: Address = Address("Teststraße", "99", "77777", "Test-Stadt", "Germany")
}
